import { z } from 'zod';
import { InterestSlug } from './interests';

/**
 * Элемент очереди модерации фото знакомств. Достаточно, чтобы модератор оценил
 * само фото и опознал юзера. Только профили в статусе PENDING.
 */
export const PhotoModerationItemDto = z.object({
  userId: z.uuid(),
  displayName: z.string(),
  username: z.string().nullable(),
  photoUrl: z.string().nullable(),
  bio: z.string().nullable(),
  age: z.number().int().min(0).max(150).nullable(),
  interests: z.array(InterestSlug),
  // Когда фото отправлено на модерацию (updatedAt профиля при загрузке).
  submittedAt: z.iso.datetime(),
  /** Доступная энергия юзера (с учётом PENDING) — для админ-очереди. */
  energyAvailable: z.number().int(),
});
export type PhotoModerationItemDto = z.infer<typeof PhotoModerationItemDto>;

export const PhotoModerationQueueResponse = z.object({
  items: z.array(PhotoModerationItemDto),
});
export type PhotoModerationQueueResponse = z.infer<typeof PhotoModerationQueueResponse>;

/**
 * Решение модератора по фото. APPROVE → APPROVED (фото в deck). HIDE →
 * HIDDEN_PERMANENT (бан фото) + причина в comment (видна юзеру в своём профиле).
 */
export const PhotoModerationDecisionBody = z.object({
  decision: z.enum(['APPROVE', 'HIDE']),
  comment: z.string().max(500).nullish(),
});
export type PhotoModerationDecisionBody = z.infer<typeof PhotoModerationDecisionBody>;
